export const documentTypes = Object.freeze({
  initialState: 1,
  calculation: 2,
  predispositionOut: 4,
  predispositionIn: 5,
  returnReceipt: 6,
  internalOutput: 7,
  inventory: 10,
  handover: 12,
  consumption: 13,
});
